import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  /**
   * General loading flag. Manually triggered
   */
  public isManualLoading = new BehaviorSubject(false);

  /**
   * Loading flag for http requests. Automatically triggered by LoaderInterceptor
   */
  public isHttpRequestLoading = new BehaviorSubject(false);
}
